// extracted by mini-css-extract-plugin
export default {"filtersGrid":"NationalSocietyReportsListPage_filtersGrid__j8cAM"};